import { useEffect } from 'react';
import { connect } from 'react-redux';
import logger from '@tcp/core/src/utils/loggerInstance';
import mediaQuickView from '@tcp/core/src/services/abstractors/mediaQuickView';
import { openQuickViewWithValues } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';

export const lookForProductInUnbxd = async (
  productIds,
  onQuickViewOpenClick,
  setQuickViewMedia
) => {
  const response = await mediaQuickView.getData({ productIds });

  const productsObj = response?.products || response?.response?.products || {};
  const products = Object.values(productsObj);
  if (products.length > 0) {
    const { productId, inventoryCount = 0 } = products[0];

    if (inventoryCount !== 0) {
      onQuickViewOpenClick({ colorProductId: productIds });
    } else {
      logger.error(`Product ${productId} is Out of Stock`);
    }
    setQuickViewMedia(false);
  }
};

const ModuleQuickView = ({ moduleQVProductId, setQuickViewMedia, onQuickViewOpenClick }) => {
  useEffect(() => {
    lookForProductInUnbxd(moduleQVProductId, onQuickViewOpenClick, setQuickViewMedia);
  }, [moduleQVProductId, setQuickViewMedia]);

  return null;
};

const mapDispatchToProps = (dispatch) => ({
  onQuickViewOpenClick: (payload) => dispatch(openQuickViewWithValues(payload)),
});

export default connect(null, mapDispatchToProps)(ModuleQuickView);
